import { useNavigate, useSearchParams } from 'react-router-dom';

const LoginErrorPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // Get error details from URL
  const errorType = searchParams.get('error');
  const errorMessage = searchParams.get('message') || 'An unknown error occurred during login.';
  
  // Define error titles based on error type
  const getErrorTitle = () => {
    switch(errorType) {
      case 'auth_error':
        return 'Authentication Error';
      case 'session_expired':
        return 'Session Expired';
      case 'invalid_session':
        return 'Invalid Session';
      case 'token_exchange_failed':
        return 'Microsoft Login Failed';
      case 'invalid_token':
        return 'Invalid Credentials';
      case 'auth_failed':
        return 'Login Failed';
      default:
        return 'Login Error';
    }
  };

  // // Clear URL params after display
  // useEffect(() => {
  //   navigate('/login-error', { replace: true });
  // }, [navigate]);

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center" style={{ backgroundColor: '#fff' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-10">
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white border-0 pt-4">
                <div className="text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="#dc3545" className="bi bi-shield-lock" viewBox="0 0 16 16">
                    <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.73 10.73 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.73 10.73 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.77 11.77 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.77 11.77 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56z"/>
                    <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z"/>
                  </svg>
                  <h2 className="mt-3 mb-1" style={{ color: '#003b93' }}>{getErrorTitle()}</h2>
                  <p className="text-muted">We encountered an issue with your login</p>
                </div>
              </div>
              <div className="card-body px-5 py-4">
                <div className="alert alert-light border" role="alert">
                  <div className="d-flex">
                    <div className="flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#003b93" className="bi bi-info-circle mt-1" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                      </svg>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="mb-0" style={{ color: '#495057' }}>{errorMessage}</p>
                    </div>
                  </div>
                </div>
                
                <div className="d-grid gap-2 mt-4">
                  <button 
                    onClick={() => navigate('/')}
                    className="btn btn-primary py-2"
                    style={{ backgroundColor: '#003b93', borderColor: '#003b93' }}
                  >
                    Return to Login Page
                  </button>
                  
                  {/* {errorType === 'auth_failed' && (
                    <button 
                      onClick={() => window.location.href = 'mailto:support@yourcompany.com'}
                      className="btn btn-outline-primary py-2"
                      style={{ color: '#003b93', borderColor: '#003b93' }}
                    >
                      Contact Support
                    </button>
                  )} */}
                </div>
              </div>
              {/* <div className="card-footer bg-white border-0 text-center pb-4">
                <p className="text-muted small mb-0">
                  Need help? <a href="/" style={{ color: '#04bcfa' }}>Visit our help center</a>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginErrorPage;